"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactIntersectionObserver = require("react-intersection-observer");

var _ResponsiveProvider = require("../../framework/ResponsiveProvider/ResponsiveProvider.index");

var _BazaarVoice = _interopRequireDefault(require("../BazaarVoice/BazaarVoice.context"));

var _QuestionsAndAnswers = require("./QuestionsAndAnswers.styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var bvQAContainerId = 'BVQAContainer';

var renderQuestionsAndAnswersSummary = function renderQuestionsAndAnswersSummary(ratingsData) {
  if (!ratingsData) {
    return null;
  }

  var totalQuestionCount = ratingsData.totalQuestionCount,
      totalAnswerCount = ratingsData.totalAnswerCount;
  return /*#__PURE__*/_react["default"].createElement(_QuestionsAndAnswers.StyledQASummary, null, /*#__PURE__*/_react["default"].createElement(_QuestionsAndAnswers.StyledQuestions, null, /*#__PURE__*/_react["default"].createElement("span", null, totalQuestionCount), ' Questions'), /*#__PURE__*/_react["default"].createElement(_QuestionsAndAnswers.StyledAnswers, null, /*#__PURE__*/_react["default"].createElement("span", null, totalAnswerCount), ' Answers'));
};

var QuestionsAndAnswers = function QuestionsAndAnswers() {
  var context = (0, _react.useContext)(_BazaarVoice["default"]);
  var getBVApi = context.getBVApi,
      isLazy = context.isLazy,
      ratingsData = context.ratingsData,
      productId = context.productId;

  var _useBreakpoint = (0, _ResponsiveProvider.useBreakpoint)(),
      isSmall = _useBreakpoint.isSmall;

  return isLazy ? /*#__PURE__*/_react["default"].createElement(_reactIntersectionObserver.InView, {
    onChange: function onChange(isInView) {
      return isInView && getBVApi();
    },
    triggerOnce: true,
    threshold: 0.5
  }, isSmall && renderQuestionsAndAnswersSummary(ratingsData), /*#__PURE__*/_react["default"].createElement("div", {
    id: bvQAContainerId,
    "data-bv-show": "questions",
    "data-bv-product-id": productId
  })) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isSmall && renderQuestionsAndAnswersSummary(ratingsData), /*#__PURE__*/_react["default"].createElement("div", {
    id: bvQAContainerId,
    "data-bv-show": "questions",
    "data-bv-product-id": productId
  }));
};

QuestionsAndAnswers.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "QuestionsAndAnswers"
};
var _default = QuestionsAndAnswers;
exports["default"] = _default;